const [d,mq] = [document, window.matchMedia('(orientation: landscape), (min-width: 750px)')];

export default class SPLASH {
  constructor (){
    this.init();
    this.promise = new Promise(r => this.resolve = r);
    d.addEventListener('DOMContentLoaded', () => {
      this.domReady()
        .then( video => this.splashReady(video) )
        .then( video => this.splashPlay(video) )
        .then( video => this.splashRemove(video) )
        .then( () => this.resolve() );
    });
    return this.promise;
  }

  init(){
    d.documentElement.classList.add('is-active-splash');
  }

  domReady() {
    d.body.insertAdjacentHTML('beforeend', `
      <section class="splash">
        <div class="splash__container">
          <video class="splash__video" width="100%" muted playsinline data-plugin="splashVideo" />
        </div>
      </section>
    `);
    const poster = {
      'pc': '/assets/img/home/splash_pc_poster.jpg',
      'sp': '/assets/img/home/splash_sp_poster.jpg',
    }
    const source = {
      'pc': `<source src="/assets/mov/splash_pc.mp4" type="video/mp4">`,
      'sp': `<source src="/assets/mov/splash_sp.mp4" type="video/mp4">`,
    }
    const video = d.querySelector('[data-plugin="splashVideo"]');
    const applyMovie = match => {
      video.innerHTML = "";
      video.insertAdjacentHTML('beforeend', match ? source.pc : source.sp );
      video.poster = match ? poster.pc : poster.sp;
      video.load();
    }

    if( video ) {
      mq.addEventListener('change', e => applyMovie(e.matches) );
      applyMovie(mq.matches);
    }

    return Promise.resolve(video);
  }

  splashReady (video) {
    return new Promise( resolve => {
      video.addEventListener('canplay', () => resolve(video));
    });
  }

  splashPlay (video) {
    return new Promise( resolve => {
      video.style.opacity = 1;
      setTimeout(() => {
        video.play();
        setTimeout(() => resolve(video), 3000); // movie length 3000ms
      }, 800); // transition: 800ms
      video.addEventListener('ended', () => resolve(video));
    });
  }

  splashRemove (video) {
    video.style.opacity = '';
    let resolve;
    const removed = new Promise(res => resolve = res);
    setTimeout(() => {
      d.documentElement.classList.add('is-fadeout-splash');
    }, 600); // transition: 800ms
    setTimeout(() => {
      d.documentElement.classList.remove('is-fadeout-splash');
      d.documentElement.classList.remove('is-active-splash');
      resolve(); // transition: 800ms + 300ms
    }, 600+800+300);
    return removed;
  }

}
